// extracted by mini-css-extract-plugin
export default {"movie":"Movie_movie__TZuBz","data":"Movie_data__ML45H","vote":"Movie_vote__5FFlF"};